import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
	Blade,
	Button,
	Layout,
	ProgressIndicator
} from "rhombus-react";

import CreativesTable from 'widgets/table/CreativesTable';
import EmptySection from 'widgets/EmptySection';
import { Assets } from 'reducers/Assets';

import { closeModal } from 'reducers/Modal';
import { MODAL_TYPES } from 'utils/constants';

import "./LinkedCreativeModal.css";

function LinkedCreativeModal() {
	const dispatch = useDispatch();
	const { linkedCreatives, modal } = useSelector((state) => {
		return {
			linkedCreatives: state.assets.linkedCreatives,
			modal: state.modal,
		};
	});

	// guard clause
	if(!modal.isOpen || modal.modalType !== MODAL_TYPES.ASSET_LINKED_CREATIVES) {return null;}

	const {
		data,
		assetName,
		linkedCreativesLoaded,
	} = linkedCreatives;

	let bladeProps = {
		verticallyCenter: true,
	};

	const emptySectionProps = {
		header: 'No Creatives',
		message: 'This Asset is not in use across any Creatives',
		src: '/images/noFiles.svg',
	};

	const renderContent = () => {
		let $content;
		if(data){
			$content = (
				<>
					<p className="message">Creatives that are using this Asset:</p>
					<CreativesTable className="linked-creatives-table" shouldLinkPreview={false} creatives={data} />
				</>
			);
		} else {
			$content = <EmptySection {...emptySectionProps} />;
		}

		return(
			<div className="linked-creative-container">
				<ProgressIndicator isLoading={!linkedCreativesLoaded} />
				{$content}
			</div>
		);
	};

	const renderFooter = () => {
		return (
			<Layout.ModalFooter>
				<Button className="close-button" theme="grey" onClick={onClose}>Close</Button>
			</Layout.ModalFooter>
		);
	};

	const onClose = () => {
		dispatch(closeModal());
		dispatch(Assets.clearLinkedCreatives());
	};

	return (
		<Blade
			type="modal"
			title={assetName ? `Linked Creatives - ${assetName}`: 'Linked Creatives'}
			className = "linked-creative-modal"
			allowFullScreen={ false }
			xClose={ true }
			bladeProps={bladeProps}
			onClose={ onClose }
			renderContent={ renderContent }
			renderFooter = { renderFooter } />
	);
}

LinkedCreativeModal.displayName = "LinkedCreativeModal";


export default LinkedCreativeModal;
